module.exports = __webpack_public_path__ + "img/angry.3b105094.svg";